// extracted by mini-css-extract-plugin
export default {"launcherContainer":"Launcher_launcherContainer__RvQX+","icon":"Launcher_icon__GORh4"};